export default "__VITE_ASSET__eZFBdOhX__"